// extracted by mini-css-extract-plugin
export default {"input":"TextInput_input__YOUtH","error":"TextInput_error__Yw5m1","errorMessage":"TextInput_errorMessage__dilJ0","label":"TextInput_label__FbhVk"};